import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../../config';
import { getDocsByIds } from '../../batchedIn';
import { handleFirebaseError } from '../../../error-handling';
import type { User } from '@/types';

export async function getOrganizationInstructors(organizationId: string): Promise<User[]> {
  try {
    const memberQuery = query(
      collection(db, 'organizationMembers'),
      where('organizationId', '==', organizationId),
      where('role', '==', 'instructor')
    );
    
    const memberSnapshot = await getDocs(memberQuery);
    const instructorIds = memberSnapshot.docs.map(doc => doc.data().userId);
    
    if (instructorIds.length === 0) {
      return [];
    }
    
    // Users 30 ids per query (Firestore's `in` limit): one unbatched query
    // failed once an organization had more than 30 instructors.
    const usersById = await getDocsByIds('users', instructorIds);
    const instructors = instructorIds
      .filter((id) => usersById.has(id))
      .map((id) => ({ id, ...usersById.get(id) })) as User[];

    return instructors;
  } catch (error) {
    handleFirebaseError(error, 'Error fetching organization instructors');
    return [];
  }
}